import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

interface FormSectionProps {
  title: string
  defaultOpen?: boolean
  children: React.ReactNode
}

export function FormSection({ title, defaultOpen = false, children }: FormSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className="border-t border-border pt-3 mt-4 first:border-t-0 first:mt-0 first:pt-0">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 w-full text-left py-1 group"
      >
        <ChevronDown
          className={`w-4 h-4 text-text-tertiary transition-transform ${isOpen ? 'rotate-180' : ''}`}
        />
        <span className="text-xs font-semibold text-text-secondary uppercase tracking-wider group-hover:text-text-primary transition-colors">
          {title}
        </span>
      </button>
      {isOpen && (
        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
          {children}
        </div>
      )}
    </div>
  )
}
